<script setup lang="ts">
import { isPlatformHg, isPlatformIs24 } from '@/helpers/Platform/Platform';

interface Props {
  selected?: boolean;
}

withDefaults(defineProps<Props>(), {
  selected: false,
});

// Platform detection - these are constants that don't need to be reactive
const isHg = isPlatformHg();
const isIs24 = isPlatformIs24();
</script>

<template>
  <div
    data-cy="FormHoverState"
    :class="{
      [$style.wrapperHg]: isHg,
      [$style.wrapperIs24]: isIs24,
      [$style.wrapperHgChecked]: isHg && selected,
      [$style.wrapperIs24Checked]: isIs24 && selected,
    }"
  >
    <slot />
  </div>
</template>

<style lang="scss" module>
@use '@/assets/variables' as *;

@mixin base-effect-hg {
  color: $color-blue-60;
  background-color: #e8effd;

  > div {
    @include common-border(#2c4fa7);
    @include common-box-shadow(rgba(44, 79, 167, 0.1));

    label {
      span {
        &::before {
          border: 2px solid $color-blue-60;
        }
      }
    }
  }
}

@mixin base-effect-is24 {
  color: $color-teal-120;
  background-color: #e9fff1;

  > div {
    @include common-border($color-teal-110);
    @include common-box-shadow(rgba(0, 219, 199, 0.1));

    label {
      span {
        &::before {
          border: 2px solid $color-teal-120;
        }
      }
    }
  }
}

.wrapperHg {
  cursor: pointer;

  label {
    pointer-events: none;
  }

  @include grid-media-query(sm) {
    &:hover {
      @include base-effect-hg;
      span {
        color: #333333;
      }
    }
  }
}

.wrapperHgChecked {
  @include base-effect-hg;

  div {
    @include font-bold;
  }
}

.wrapperIs24 {
  cursor: pointer;

  label {
    pointer-events: none;
  }

  @include grid-media-query(sm) {
    &:hover {
      @include base-effect-is24;
      span {
        color: #333333;
      }
    }
  }
}

.wrapperIs24Checked {
  @include base-effect-is24;

  div {
    @include font-bold;
  }

  input[type='radio'] {
    + span > span:first-child {
      &::before {
        border-color: $color-teal-120 !important;
      }

      &::after {
        background-color: $color-teal-120;
        border-color: $color-teal-120;
      }
    }
  }
}
</style>
